import script from "./performance.vue?vue&type=script&setup=true&lang=js"
export * from "./performance.vue?vue&type=script&setup=true&lang=js"

import "./performance.vue?vue&type=style&index=0&id=076d4cca&lang=less&scoped=true"

import exportComponent from "/root/workspace/dsx-frontend_gib7/h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-076d4cca"]])

export default __exports__